exports.call_wasm_fn = function (name) {
  return function (argsArray) {
    return window.wasmModule[name].apply(null, argsArray);
  };
};

exports.getWasmModule = function () {
  return window.wasmModule;
};
